import React from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Paper,
} from "@mui/material";
import InvoiceHeaderStyles from "../../invoiceGeneration/InvoiceHeaderStyles";

type ReceiptHeaderProps = {
  previewData: any;
};

const ReceiptHeader: React.FC<ReceiptHeaderProps> = ({ previewData }) => {
  const org = previewData?.org || {};
  const styles = InvoiceHeaderStyles;

  return (
    <TableContainer component={Paper}>
      <Table>
        <TableBody>
          <TableRow>
            <TableCell sx={styles.logoCell} rowSpan={5} />
            <TableCell sx={styles.headerCell}> Credit Note</TableCell>
          </TableRow>
          <TableRow>
            <TableCell sx={styles.subHeaderCell}>{org.name} </TableCell>
          </TableRow>
          <TableRow>
            <TableCell sx={styles.addressCell} data-testid="registered-address">
              <span style={{ fontWeight: 700, fontSize: "9px" }}>
                Registered Address:
              </span>
              {org.registeredAddress}
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell
              sx={styles.factoryAddressCell}
              data-testid="factory-address"
            >
              <span style={{ fontWeight: 700, fontSize: "9px" }}>
                Factory Address:
              </span>
              {org.factoryAddress}
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell sx={styles.footerCell} colSpan={2}>
              <span style={{ fontWeight: 700, fontSize: "9px" }}>Tel:</span>
              {org.tel}
              <span style={{ fontWeight: 700, fontSize: "9px" }}>| Email:</span>
              {org.email}
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default ReceiptHeader;
